import { render } from "./CreateQuestiontModal.vue?vue&type=template&id=4070ac84"
import script from "./CreateQuestiontModal.vue?vue&type=script&lang=js"
export * from "./CreateQuestiontModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__